"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactComponents = require("@ui-propulsion/react-components");
var _link_expired = _interopRequireDefault(require("../images/link_expired.png"));
var _email_verified = _interopRequireDefault(require("../images/email_verified.png"));
var Page = function Page(props) {
  var linkExpired = props.linkExpired,
    emailSent = props.emailSent,
    resendEmail = props.resendEmail,
    market = props.market;
  var renderPage = function renderPage() {
    if (!linkExpired) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
        src: _email_verified.default,
        alt: "A mail icon with green check depicting successful email verification"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "email-verification__text"
      }, "Thank you for verifying your email address."), /*#__PURE__*/_react.default.createElement("div", {
        className: "email-verification__subtext"
      }, "You will receive an email with further instructions on how to proceed with your application."));
    }
    if (linkExpired) {
      if (emailSent) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
          src: _email_verified.default,
          alt: "A mail icon with green check depicting successful email verification"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "email-verification__text"
        }, "A new email has been sent to your account to verify your email address."));
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
        src: _link_expired.default,
        alt: "A mail icon with red exclamation depicting email verification failure"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "email-verification__text email-verification__text--expired"
      }, "Sorry, the link has expired."), /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
        className: "email-verification__button",
        type: "button",
        onClick: resendEmail
      }, "Resend Verification"));
    }
  };
  var getCustomerCareContact = function getCustomerCareContact() {
    switch (market) {
      case 'EDUCATION':
        return '1-800-920-9777';
      case 'PATIENT_SOLUTIONS':
        return '1-800-630-1663';
      default:
        return '1-800-630-1663';
      // Default to PATIENT_SOLUTIONS
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "email-verification"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "email-verification__content"
  }, renderPage()), /*#__PURE__*/_react.default.createElement("div", {
    className: "email-verification__footer"
  }, "If you have any questions or need any assistance, please contact Customer Care at ", getCustomerCareContact(), "."));
};
Page.propTypes = {
  linkExpired: _propTypes.bool,
  emailSent: _propTypes.bool,
  resendEmail: _propTypes.func.isRequired,
  market: _propTypes.string.isRequired
};
Page.defaultProps = {
  linkExpired: false,
  emailSent: false
};
var _default = Page;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/email-verification/lib/styles.scss');